// filterNode.js

import { useState } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const FilterNode = ({ id, data }) => {
    const [condition, setCondition] = useState(data?.condition || '');

    return (
        <BaseNode
            id={id}
            title="Filter Node"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-input` },
                { type: 'source', position: Position.Right, id: `${id}-passed`, style: { top: '33%' } },
                { type: 'source', position: Position.Right, id: `${id}-failed`, style: { top: '66%' } }
            ]}
        >
            <label style={{ display: 'flex', flexDirection: 'column', fontSize: '12px' }}>
                Condition:
                <input
                    type="text"
                    value={condition}
                    onChange={(e) => setCondition(e.target.value)}
                    placeholder="e.g. length > 5"
                    style={{ marginTop: '4px' }}
                />
            </label>
        </BaseNode>
    );
}
